class QuizApi {
  static async fetchQuestions() {
    const apiUrl = 'https://d1.global-polluelo5v.workers.dev/frases'

    try {
      const response = await fetch(apiUrl)
      if (!response.ok) {
        throw new Error(`Error al obtener las preguntas: ${response.statusText}`)
      }
      const data = await response.json()

      return data
    } catch (error) {
      console.error('Error al llamar a la API:', error)
      throw error
    }
  }

  static async markWordForReview(data = {}) {
    const apiUrl = 'https://d1.global-polluelo5v.workers.dev/review_words'

    const generateId = () => {
      try {
        if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
          const arr = new Uint8Array(16)
          crypto.getRandomValues(arr)
          return Array.from(arr)
            .map((b) => b.toString(16).padStart(2, '0'))
            .join('')
            .toLowerCase()
        }
      } catch (e) {
        // fallthrough
      }
      return (Date.now().toString(16) + Math.random().toString(16).slice(2, 18)).slice(0, 32)
    }

    const now = new Date().toISOString()

    const payload = {
      id: data.id || generateId(),
      palabra_castellano: data.palabra_castellano || data.castellano || data.word || '',
      hiragana: data.hiragana || data.hiragana || '',
      kanji: data.kanji || null,
      romaji: data.romaji || data.romaji || '',
      review_flag: 'S',
      review_count: typeof data.review_count === 'number' ? data.review_count : 1,
      last_reviewed_at: data.last_reviewed_at || now,
      source: data.source || 'unknown',
      category: data.category || '',
      notes: data.notes || data.texto || '',
      user_id: data.user_id || null,
      created_at: data.created_at || now,
      updated_at: data.updated_at || now
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })

      if (!response.ok) {
        throw new Error(`Error al marcar la palabra: ${response.statusText}`)
      }

      return response.json().catch(() => ({}))
    } catch (error) {
      console.error('Error al marcar la palabra para repasar:', error)
      throw error
    }
  }

  static async getReviewWords({
    user_id = null,
    review_flag = null,
    category = null,
    limit = 100,
    offset = 0
  } = {}) {
    const apiUrlBase = 'https://d1.global-polluelo5v.workers.dev/review_words'
    const params = new URLSearchParams()

    if (user_id) params.append('user_id', user_id)
    if (review_flag) params.append('review_flag', review_flag)
    if (category) params.append('category', category)
    if (limit !== null) params.append('limit', String(limit))
    if (offset !== null) params.append('offset', String(offset))

    const url = `${apiUrlBase}${params.toString() ? `?${params.toString()}` : ''}`

    try {
      const response = await fetch(url)
      if (!response.ok) {
        throw new Error(`Error al obtener palabras de repaso: ${response.statusText}`)
      }
      return response.json()
    } catch (error) {
      console.error('Error en getReviewWords:', error)
      throw error
    }
  }
}

export default QuizApi
